import TokenService from '../TokenService'
import AppConfig from '../../config'
import Qs from 'qs'

export default class RequestMiddleware {
    /**
     * for more details about axiosConfig go to https://github.com/axios/axios#request-config
     * @param axiosConfig
     * @returns axiosConfig
     */
    onRequest(axiosConfig) {

        // `baseURL` will be prepended to `url` unless `url` is absolute.
        // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
        // to methods of that instance.

        axiosConfig.baseURL = AppConfig.server_url;
        axiosConfig.headers['Content-Type'] = 'application/json';
        axiosConfig.headers['x-api-key'] = AppConfig.client_token;

        axiosConfig.headers['Accept-Language'] = AppConfig.local;

        axiosConfig.headers['Access-Control-Allow-Origin'] = '*';
        if (TokenService.getToken()) {
            axiosConfig.headers['Authorization'] = TokenService.getToken();
        }
        // Nasted Params Serializer
        axiosConfig.paramsSerializer = params => {
            return Qs.stringify(params, {
                arrayFormat: "brackets",
                encode: false
            });
        };

        return axiosConfig;
    }
}